import React, { useEffect, useMemo, useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux';
import { ButtBox } from '@tecuity/granite-ui/ButtBox';
import { Checkbox } from '@tecuity/granite-ui/Checkbox';
import RightArrow from '@tecuity/sos-icons/react/right-arrow';
import ActionButton, { ActionButtonGroup } from '../ActionButton/ActionButton';
import { Spinner } from '../Loaders/Loaders'

const BulkAssignment = (props) => {
  const { bulkSelectedPeople, setBulkSelectedPeople, bulkSelectedItems, changeBulkUsers, loading } =
    props
  const { activeCategoryId, workviewCategoryUsers } = useSelector(
    (state) => state.workview2,
    shallowEqual
  )
  const [showAssignWorkError, setShowAssignWorkError] = useState(false);

  useEffect(() => {
    setShowAssignWorkError(false);
  }, [bulkSelectedItems])

  const filteredPeople = useMemo(() => {
    const currentCategoryUsers = workviewCategoryUsers.find((category) => activeCategoryId === category.WorkViewID)
    let users = currentCategoryUsers && currentCategoryUsers.Users ? currentCategoryUsers.Users : [];
    users = users.sort((a, b) => a.Name > b.Name ? 1 : -1)
    return users
  }, [activeCategoryId, workviewCategoryUsers])

  const isChecked = useMemo(() => {
    if (filteredPeople.length === 0) return false;
    return bulkSelectedPeople.length === filteredPeople.length;
  }, [bulkSelectedPeople, filteredPeople])

  const clickSelectAll = (checked) => {
    setShowAssignWorkError(false);
    if(checked) {
      setBulkSelectedPeople(filteredPeople.map((person) => {
        return person.AppUserID
      }))
    } else {
      setBulkSelectedPeople([])
    }
  }

  const selectPerson = (checked, personId) => {
    setShowAssignWorkError(false);
    if (checked) {
      setBulkSelectedPeople([...bulkSelectedPeople, personId])
    } else {
      setBulkSelectedPeople([...bulkSelectedPeople.filter((AppUserID) => AppUserID !== personId)])
    }
  }

  const clickAssignWork = () => {
    if (bulkSelectedItems.length === 0 || bulkSelectedPeople.length === 0) {
      setShowAssignWorkError(true);
      return;
    }

    // Create acceptable data to send to endpoint
    const assignments = []
    let personIndex = 0;
    bulkSelectedItems.forEach((itemId) => {
      const personId = bulkSelectedPeople[personIndex++];
      assignments.push({ workviewItemId: itemId, userId: personId })
      if (personIndex === bulkSelectedPeople.length) personIndex = 0;
    })

    // console.log(assignments);
    changeBulkUsers(assignments);
  }

  return (
    <div>
      <ButtBox 
        className="buttbox" 
        label="Select All" 
        checked={isChecked}
        onChange={clickSelectAll}
        />
      <div className={`filtered-people-checkboxes`}>
        {filteredPeople.map((person) => {
          const isChecked = bulkSelectedPeople.includes(person.AppUserID);
          return (
            <Checkbox label={person.Name} onChange={(checked) => selectPerson(checked, person.AppUserID)} checked={isChecked} key={person.AppUserID}/>
          )
        })}
      </div>
      {!loading 
      ? <ActionButtonGroup>
        <ActionButton label="Assign Work" onClick={clickAssignWork}>
          <RightArrow />
        </ActionButton>
      </ActionButtonGroup> 
      : <div className="bulk-assign-loader">
        <Spinner className="page-loader" themeColor="dark-neutral" />
      </div>}
      {showAssignWorkError && <div>
        <h2>At least 1 work item and 1 person MUST be selected.</h2>  
      </div>}
    </div>
  )
}

export default BulkAssignment